import { useQuery } from "@tanstack/react-query";
import {
	getCostCenters,
	getFirstTurnedRollsData,
	type GetFirstTurnedRollsParams,
} from "../repositories/FirstTurnedRollsRepository";

type UseFirstTurnedRollsParams = Omit<
	GetFirstTurnedRollsParams,
	"signal" | "costCenterId"
> & {
	costCenterId: number | null;
};

export const useFirstTurnedRolls = ({
	start,
	end,
	costCenterId,
}: UseFirstTurnedRollsParams) => {
	return useQuery({
		queryKey: ["firstTurnedRolls", start, end, costCenterId],
		queryFn: ({ signal }) =>
			getFirstTurnedRollsData({
				start,
				end,
				costCenterId: costCenterId as number,
				signal,
			}),
		enabled: !!start && !!end && costCenterId != null,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};

export const useCostCenters = () => {
	return useQuery({
		queryKey: ["firstTurnedRollsCostCenters"],
		queryFn: ({ signal }) => getCostCenters(signal),
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
